<template>
  <section class="page-block services-block">
    <div class="wide">
      <div class="mid">
        <div class="narrow">
          <div class="list barbers">
            <p class="title">{{ $t('ServicesBlock.ServicesBarbers.Title') }}
              <span
                :style="{'background-image': 'url(' + require('@/i/services/line-end-1.svg') + ')'}"
              ></span>
            </p>
            <p class="item">
              <label>{{ $t('ServicesBlock.ServicesBarbers.A') }}</label>
              <span><div>{{ $t('ServicesBlock.ServicesBarbers.Aprice') }}</div>&nbsp;₴</span>
            </p>
            <p class="item">
              <label>{{ $t('ServicesBlock.ServicesBarbers.B') }}</label>
              <span><div>{{ $t('ServicesBlock.ServicesBarbers.Bprice') }}</div>&nbsp;₴</span>
            </p>
            <p class="item">
              <label>{{ $t('ServicesBlock.ServicesBarbers.C') }}</label>
              <span><div>{{ $t('ServicesBlock.ServicesBarbers.Cprice') }}</div>&nbsp;₴</span>
            </p>
            <p class="item">
              <label>{{ $t('ServicesBlock.ServicesBarbers.D') }}</label>
              <span><div>{{ $t('ServicesBlock.ServicesBarbers.Dprice') }}</div>&nbsp;₴</span>
            </p>
            <p class="item">
              <label>{{ $t('ServicesBlock.ServicesBarbers.E') }}</label>
              <span><div>{{ $t('ServicesBlock.ServicesBarbers.Eprice') }}</div>&nbsp;₴</span>
            </p>
            <p class="item">
              <label>{{ $t('ServicesBlock.ServicesBarbers.F') }}</label>
              <span><div>{{ $t('ServicesBlock.ServicesBarbers.Fprice') }}</div>&nbsp;₴</span>
            </p>
            <p class="item">
              <label>{{ $t('ServicesBlock.ServicesBarbers.G') }}</label>
              <span><div>{{ $t('ServicesBlock.ServicesBarbers.Gprice') }}</div>&nbsp;₴</span>
            </p>
            <p class="item">
              <label>{{ $t('ServicesBlock.ServicesBarbers.H') }}</label>
              <span><div>{{ $t('ServicesBlock.ServicesBarbers.Hprice') }}</div>&nbsp;₴</span>
            </p>
          </div>
          <!-- <div class="list trainee">
            <p class="title">{{ $t('ServicesBlock.ServicesTrainers.Title') }}
              <span
                :style="{'background-image': 'url(' + require('@/i/services/line-end-2.svg') + ')'}"
              ></span>
            </p>
            <p class="item">
              <label>{{ $t('ServicesBlock.ServicesTrainers.A') }}</label>
              <span><div>{{ $t('ServicesBlock.ServicesTrainers.Aprice') }}</div>&nbsp;₴</span>
            </p>
            <p class="item">
              <label>{{ $t('ServicesBlock.ServicesTrainers.B') }}</label>
              <span><div>{{ $t('ServicesBlock.ServicesTrainers.Bprice') }}</div>&nbsp;₴</span>
            </p>
            <p class="item">
              <label>{{ $t('ServicesBlock.ServicesTrainers.C') }}</label>
              <span><div>{{ $t('ServicesBlock.ServicesTrainers.Cprice') }}</div>&nbsp;₴</span>
            </p>
            <p class="item">
              <label>{{ $t('ServicesBlock.ServicesTrainers.D') }}</label>
              <span><div>{{ $t('ServicesBlock.ServicesTrainers.Dprice') }}</div>&nbsp;₴</span>
            </p>
            <p class="item">
              <label>{{ $t('ServicesBlock.ServicesTrainers.E') }}</label>
              <span><div>{{ $t('ServicesBlock.ServicesTrainers.Eprice') }}</div>&nbsp;₴</span>
            </p>
            <p class="item">
              <label>{{ $t('ServicesBlock.ServicesTrainers.F') }}</label>
              <span><div>{{ $t('ServicesBlock.ServicesTrainers.Fprice') }}</div>&nbsp;₴</span>
            </p>
          </div> -->
          <!-- <div class="list tattoo">
            <p class="title">{{ $t('ServicesBlock.ServicesTattoo.Title') }}
              <span
                :style="{'background-image': 'url(' + require('@/i/services/line-end-3.svg') + ')'}"
              ></span>
            </p>
            <img src="@/i/services/tattoo.png"><p class="item">
              <label>{{ $t('ServicesBlock.ServicesTattoo.A') }}</label>
              <span><div>{{ $t('ServicesBlock.ServicesTattoo.Aphone') }}</div></span>
            </p>
          </div> -->
        </div>
      </div>
    </div>
  </section>
</template>

<script>

export default {
  name: 'service-block',
  components: {
  },
  props: {
  }
}
</script>
